export const CLEAN_PLUGROUP = 'clean_pluGroup';
export const SET_PLUGROUP = 'set_pluGroup';
export const SET_PLUGROUP_LIST = 'set_pluGroup_list';

export const SYNC_FAILED = 'update_sync_error';
export const SYNC_FINISHED = 'pluGroup_sync_has_finished';
export const SYNC_INITIATED = 'pluGroups_sync_was_initiated';
export const PLU_GROUP_SYNC = 'pluGroup_sync_was_initiated';

export const CREATE_INITIATED = 'pluGroup_create_initiated';
export const PLUGROUP_CREATED = 'pluGroup_created';

export const UPDATE_INITIATED = 'pluGroup_update_initiated';
export const PLUGROUP_UPDATED = 'pluGroup_updated';

export const DELETE_INITIATED = 'pluGroup_delete_initiated';
export const PLUGROUP_DELETED = 'pluGroup_deleted';
